import { useState, useCallback } from 'react';
import { pushErrorFromAPI } from 'src/utilities/notifications';
import { IGroup } from 'src/utilities/useSearchHooks';
import { getEmployeeGroupsSelections } from 'src/components/enterprise/features/Employee/EmployeeDetailsPage/components/EmployeeGroupsWrapper/api/getEmployeeGroupsSelectionsAPI';

export interface UseGetEmployeeGroupsSelectionsProps {
  corpId: string;
  employeeId: string;
}

export interface UseGetEmployeeGroupsSelectionsReturn {
  groups: IGroup[];
  isLoading: boolean;
  fetch: () => Promise<void>;
}

export function useGetEmployeeGroupsSelections({
  corpId,
  employeeId,
}: UseGetEmployeeGroupsSelectionsProps): UseGetEmployeeGroupsSelectionsReturn {
  const [groups, setGroups] = useState<IGroup[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetch = useCallback(async (): Promise<void> => {
    try {
      setIsLoading(true);
      const fetchedGroups = await getEmployeeGroupsSelections(
        corpId,
        employeeId
      );
      setGroups(fetchedGroups);
    } catch (error) {
      pushErrorFromAPI(error);
    } finally {
      setIsLoading(false);
    }
  }, [corpId, employeeId]);

  return {
    groups,
    isLoading,
    fetch,
  };
}
